(function () {
  function ready(fn) { if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }

  ready(function () {
    /* ---------- mobile menu ---------- */
    var head = document.querySelector('.site-head');
    var menuBtn = document.querySelector('.menu-btn');
    if (head && menuBtn) {
      menuBtn.addEventListener('click', function () {
        var open = head.classList.toggle('open');
        menuBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
        menuBtn.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && head.classList.contains('open')) {
          head.classList.remove('open'); menuBtn.setAttribute('aria-expanded', 'false'); menuBtn.focus();
        }
      });
    }

    /* ---------- product gallery ---------- */
    var slides = document.querySelectorAll('.stage .slide');
    var thumbs = document.querySelectorAll('.thumb');
    var current = 0;
    function show(i) {
      if (!slides.length) return;
      current = (i + slides.length) % slides.length;
      slides.forEach(function (s, n) { s.classList.toggle('on', n === current); });
      thumbs.forEach(function (t, n) { t.classList.toggle('active', n === current); t.setAttribute('aria-pressed', n === current ? 'true' : 'false'); });
    }
    thumbs.forEach(function (t, n) { t.addEventListener('click', function () { show(n); }); });
    var stage = document.querySelector('.stage');
    if (stage && slides.length > 1) {
      var x0 = null;
      stage.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      stage.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0;
        if (Math.abs(dx) > 40) show(current + (dx < 0 ? 1 : -1));
        x0 = null;
      });
    }

    /* ---------- rounds (pack picker) ---------- */
    var section = document.querySelector('[data-product-section]');
    if (section) {
      var idInput = section.querySelector('[data-id-input]');
      var qtyInput = section.querySelector('[data-qty-input]');
      var priceNow = section.querySelector('[data-price-now]');
      var priceOld = section.querySelector('[data-price-old]');
      var saveTag = section.querySelector('[data-save]');
      var saveAmt = section.querySelector('[data-save-amount]');
      var buyBtns = section.querySelectorAll('[data-buy-btn]');
      var waBtn = section.querySelector('[data-wa-order]');
      var stickyPrice = document.querySelector('[data-sticky-price]');
      var stickyPack = document.querySelector('[data-sticky-pack]');
      var productTitle = stickyPack ? stickyPack.textContent.split(',')[0] : '';

      var syncRound = function () {
        var r = section.querySelector('[data-rounds] input:checked');
        if (!r) return;
        if (idInput) idInput.value = r.dataset.variant;
        if (qtyInput) qtyInput.value = r.dataset.qty || 1;
        if (priceNow) priceNow.textContent = r.dataset.price;
        var hasCompare = !!r.dataset.compare;
        if (priceOld) { priceOld.hidden = !hasCompare; priceOld.textContent = r.dataset.compare || ''; }
        if (saveTag) { saveTag.hidden = !hasCompare; if (saveAmt) saveAmt.textContent = r.dataset.save || ''; }
        var available = r.dataset.available !== 'false';
        buyBtns.forEach(function (b) { b.disabled = !available; });
        if (stickyPrice) stickyPrice.textContent = r.dataset.price;
        if (stickyPack) stickyPack.textContent = productTitle + (r.dataset.pack ? ', ' + r.dataset.pack : '');
        if (waBtn) {
          var base = waBtn.dataset.waBase || '';
          var text = base + (r.dataset.pack ? ' (' + r.dataset.pack + ')' : '');
          waBtn.href = waBtn.href.split('?')[0] + '?text=' + encodeURIComponent(text);
        }
      };
      section.querySelectorAll('[data-rounds] input').forEach(function (r) { r.addEventListener('change', syncRound); });
      syncRound();

      var vSelect = section.querySelector('[data-variant-select]');
      if (vSelect && idInput) {
        vSelect.addEventListener('change', function () {
          idInput.value = vSelect.value;
          var opt = vSelect.options[vSelect.selectedIndex];
          if (priceNow && opt.dataset.price) priceNow.textContent = opt.dataset.price;
          if (stickyPrice && opt.dataset.price) stickyPrice.textContent = opt.dataset.price;
        });
      }

      document.querySelectorAll('[data-pick-round]').forEach(function (a) {
        a.addEventListener('click', function () {
          var inputs = section.querySelectorAll('[data-rounds] input');
          var r = inputs[parseInt(a.dataset.pickRound, 10) - 1];
          if (r && !r.disabled) { r.checked = true; syncRound(); }
        });
      });
    }

    /* ---------- sticky order bar ---------- */
    var sticky = document.querySelector('.sticky-buy');
    var buyCtas = document.querySelector('.buy-ctas');
    if (sticky && buyCtas && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var e = entries[0];
        sticky.classList.toggle('show', !e.isIntersecting && e.boundingClientRect.top < 0);
      }).observe(buyCtas);
    }

    /* ---------- reviews carousel ---------- */
    document.querySelectorAll('.rv-carousel').forEach(function (c) {
      var track = c.querySelector('.rv-track');
      var prev = c.querySelector('.rv-arrow.prev');
      var next = c.querySelector('.rv-arrow.next');
      if (!track || !prev || !next) return;
      function step() {
        var card = track.querySelector('.rv-card'); if (!card) return 300;
        var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        return card.getBoundingClientRect().width + gap;
      }
      function update() {
        var max = track.scrollWidth - track.clientWidth;
        prev.hidden = next.hidden = !(max > 4);
        prev.disabled = track.scrollLeft <= 4;
        next.disabled = track.scrollLeft >= max - 4;
        var media = track.querySelector('.rv-media');
        if (media) c.style.setProperty('--arrow-top', (media.getBoundingClientRect().height / 2) + 'px');
      }
      prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
      track.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
      window.addEventListener('resize', update);
      window.addEventListener('load', update);
      update();
    });

    /* ---------- contact form: send the same message on WhatsApp ---------- */
    document.querySelectorAll('[data-wa-compose]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var form = btn.closest('form');
        if (!form) return;
        var get = function (sel) { var el = form.querySelector(sel); return el ? el.value.trim() : ''; };
        var nameEl = form.querySelector('[name="contact[name]"]');
        var bodyEl = form.querySelector('[name="contact[body]"]');
        if ((nameEl && !nameEl.reportValidity()) || (bodyEl && !bodyEl.reportValidity())) return;
        var lines = ['Assalam o Alaikum, Man Up team.', '', 'Name: ' + get('[name="contact[name]"]')];
        if (get('[name="contact[phone]"]')) lines.push('Phone: ' + get('[name="contact[phone]"]'));
        if (get('[name="contact[Order number]"]')) lines.push('Order number: ' + get('[name="contact[Order number]"]'));
        if (get('[name="contact[Topic]"]')) lines.push('Topic: ' + get('[name="contact[Topic]"]'));
        lines.push('', get('[name="contact[body]"]'));
        window.open('https://wa.me/' + btn.dataset.waCompose + '?text=' + encodeURIComponent(lines.join('\n')), '_blank', 'noopener');
      });
    });

    /* ---------- cart quantity buttons ---------- */
    document.querySelectorAll('[data-qty-step]').forEach(function (b) {
      b.addEventListener('click', function () {
        var input = b.parentElement.querySelector('input');
        if (!input) return;
        var v = Math.max(0, (parseInt(input.value, 10) || 0) + parseInt(b.dataset.qtyStep, 10));
        input.value = v;
      });
    });

    /* ---------- policy pages: build the table of contents ---------- */
    var toc = document.querySelector('[data-toc] ol');
    var doc = document.querySelector('[data-doc]');
    if (toc && doc) {
      var heads = doc.querySelectorAll('.rte h2');
      if (!heads.length) { toc.parentElement.hidden = true; }
      heads.forEach(function (h, i) {
        if (!h.id) h.id = 'section-' + (i + 1);
        var li = document.createElement('li');
        var a = document.createElement('a');
        a.href = '#' + h.id; a.textContent = h.textContent.replace(/^\s*\d+\.\s*/, '');
        li.appendChild(a); toc.appendChild(li);
      });
    }

    /* ---------- login page: show password reset ---------- */
    var recoverLink = document.querySelector('[data-toggle-recover]');
    if (recoverLink) {
      recoverLink.addEventListener('click', function (e) {
        e.preventDefault();
        var box = document.getElementById('recover');
        if (box) { box.classList.add('show'); box.querySelector('input').focus(); }
      });
    }
  });
})();
